import { Button, Grid, MenuItem, Typography } from "@material-ui/core";
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import "moment/locale/es";

import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useForm } from "../../../hooks/useForm";
import {
  resetValorizaciones,
  postFacturaTurnoCoseguro,
  // getValorizacionesCoseguro,
  // postTurnoImporteCoseguro,
} from "../../../actions/coseguros/coseguros";
import { confirmarAsistenciaTurno, fetchTurnosTomadosPorFecha } from "../../../actions/turnos/agenda";

import { AlertaPago } from "./AlertaPago";
import { TURNOS_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const PagoCoseguro = (props) => {
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const { valorizaciones } = useSelector((state) => state.coseguros);
  const { items: mediosPago } = useSelector( state => state.medioPago ); 
  const [openModalAlertPago, setOpenModalAlertPago] = useState(false);
  const [datosAlertPago, setDatosAlertPago] = useState({
    titulo: "",
    mensaje: "",
    impago: false,
  });

  const montoTotal = valorizaciones?.exento
    ? valorizaciones?.deudaAnterior
    : valorizaciones?.importe + valorizaciones?.deudaAnterior;

  const initialValues = {
    nroLote: "",
    nroCupon: "",
    idMedioPago: ""
  };

  const [formValues, handleInputChange] = useForm(initialValues);

  const { nroLote, nroCupon, idMedioPago } = formValues;

  const {
    turnoDemanda,
    openDemandaLaboratorio,
    setEsPantallaFormulario,
    setOpenDemandaLaboratorio,
    usuarioTurnoSeleccionado: { idAgenda, idAfiliadoExterno },
  } = props;

  const enabledSaltearPagoButton = validarSoloUnPermiso(
    permisosUser,
    TURNOS_PERMISOS.PERMITE_SALTAR_PAGO_AUNQ_EXEDE_LIMITE
  );

  const disabledSaltearPagoButton =
    (!valorizaciones?.permiteSaltarPago &&
    !valorizaciones?.exento &&
    !enabledSaltearPagoButton &&
    valorizaciones?.importe > 0)
    || idAfiliadoExterno
    || turnoDemanda;

  useEffect(() => {
    return () => {
      dispatch(resetValorizaciones());
    };
  }, [dispatch]);

  useEffect(() => {
    return () => {
      setEsPantallaFormulario(true);
    };
  }, [setEsPantallaFormulario]);

  const closeModalAlertPagoHandler = () => {
    setOpenModalAlertPago(false);
  };

  const openModalAlertPagoHandler = async (impago) => {
    let isFormValid = false;

    if (impago) {
      isFormValid = await formRef.current.isFormValid(true);
    } else {
      isFormValid = await formRef.current.isFormValid(false);
    }

    if (isFormValid || impago) {
      const msj = impago  
        ? 
          montoTotal >= 0
            ?
              {
                titulo: 'Saltear Pago',
                descrip: 'saltear el pago'
              }
            :
              {
                titulo: 'Turno',
                descrip: 'confirmar la asistencia'
              }
        : 
          {
            titulo: 'Pago',
            descrip: 'realizar el pago'
          };
                      
      setDatosAlertPago({
        titulo: msj.titulo,
        mensaje: msj.descrip,
        impago,
      });
      setOpenModalAlertPago(true);
    }
  };

  const onSubmitPagoCoseguroHandler = (impago) => {
    const dataPost = {
      idAgenda,
      importe: Number(valorizaciones?.importe),
      nroLote: impago ? null : Number(nroLote),
      nroCupon: impago ? null : Number(nroCupon),
      idMedioPago: impago ? null : Number(idMedioPago),
      importeAbonado: impago
        ? 0
        : Number(valorizaciones?.importe + valorizaciones?.deudaAnterior),
      exento: valorizaciones?.exento,
    };

    dispatch(
      postFacturaTurnoCoseguro(
        dataPost,
        props.closeModalCoseguro,
        confirmarAsistenciaTurno,
        idAgenda,
        impago,
        (turnoDemanda && openDemandaLaboratorio) ? () => setOpenDemandaLaboratorio(false) : null,
        props.fecha,
        props.idProfesional
      )
    );
  };

  return (
    <React.Fragment>
      <AlertaPago
        open={openModalAlertPago}
        closeAlertModal={closeModalAlertPagoHandler}
        datosAlertPago={datosAlertPago}
        confirmButtonAction={onSubmitPagoCoseguroHandler.bind(
          this,
          datosAlertPago?.impago
        )}
      />
      <ValidatorForm ref={formRef}>
        <Grid container spacing={2} style={{ width: "65%", margin: "auto" }}>
          <Grid item xs={12}>
            <Typography variant="h5" style={{ textAlign: "center", color: montoTotal >= 0 ? 'red' : 'green' }}>
              {`${
                montoTotal >= 0
                  ? `Monto Total: $${montoTotal.toFixed(2)}`
                  : `Nuevo Saldo a Favor: $${Math.abs(montoTotal).toFixed(2)}`
              }`}
            </Typography>
            {!valorizaciones?.exento && (
              <Typography
                variant="h6"
                style={{
                  textAlign: "center",
                  marginTop: "1rem",
                  fontSize: "1.1rem",
                }}
              >
                Monto Turno: ${Number(valorizaciones?.importe).toFixed(2)}
              </Typography>
            )}
            {Number(valorizaciones?.deudaAnterior) > 0 && (
              <Typography
                variant="h6"
                style={{
                  textAlign: "center",
                  fontSize: "1.1rem",
                  color: "red",
                }}
              >
                Deuda Anterior: $
                {Number(valorizaciones?.deudaAnterior).toFixed(2)}
              </Typography>
            )}
            {Number(valorizaciones?.deudaAnterior) < 0 && (
              <Typography
                variant="h6"
                style={{
                  textAlign: "center",
                  fontSize: "1.1rem",
                  color: "green",
                }}
              >
                Saldo a Favor: $
                {Math.abs(Number(valorizaciones?.deudaAnterior)).toFixed(2)}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" style={{ textAlign: "center" }}>
              {new Date().toLocaleDateString("es", optionsfecha)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextValidator
              fullWidth
              autoComplete="off"
              style={{ marginTop: -10 }}
              margin="normal"
              label="Nro. Lote"
              name="nroLote"
              value={nroLote}
              onChange={handleInputChange}
              disabled={
                montoTotal <= 0 ||
                (valorizaciones?.importe === 0 &&
                  valorizaciones?.deudaAnterior === 0)
              }
              validators={[
                "required",
                "matchRegexp:^[0-9]+$",
                "minNumber: 1",
                "maxNumber: 999999999",
              ]}
              errorMessages={[
                "Campo obligatorio",
                "Solo se permiten números positivos enteros",
                "No puede ser 0",
                "Solo se permite un maximo de 9 caracteres númericos",
              ]}
            />
          </Grid>
          <Grid item xs={12}>
            <TextValidator
              fullWidth
              autoComplete="off"
              style={{ marginTop: -10 }}
              margin="normal"
              label="Nro. Cupón"
              name="nroCupon"
              value={nroCupon}
              onChange={handleInputChange}
              disabled={
                montoTotal <= 0 ||
                (valorizaciones?.importe === 0 &&
                  valorizaciones?.deudaAnterior === 0)
              }
              validators={[
                "required",
                "matchRegexp:^[0-9]+$",
                "minNumber: 1",
                "maxNumber: 9999999999",
              ]}
              errorMessages={[
                "Campo obligatorio",
                "Solo se permiten números positivos enteros",
                "No puede ser 0",
                "Solo se permite un maximo de 10 caracteres númericos",
              ]}
            />
          </Grid>
          <Grid item xs={12}>
            <SelectValidator
              value={idMedioPago}
              style={{marginBottom: 10, marginTop: -10}}
              onChange={(e) => {
                handleInputChange(e);
              }}
              label="Medio de Pago"
              name="idMedioPago"
              validators={["required"]}
              errorMessages={["El Medio de Pago es requerido"]}
              fullWidth
              disabled={
                montoTotal <= 0 ||
                (valorizaciones?.importe === 0 &&
                  valorizaciones?.deudaAnterior === 0)
              }
            >
              <MenuItem value="">
                <em>Seleccione</em>
              </MenuItem>
              {validarSoloUnPermiso(permisosUser,
                TURNOS_PERMISOS.PERMITE_SELECCIONAR_MEDIOS_PAGO_NO_HABILITADOS)
                ?
                  mediosPago.map((item) => (
                    <MenuItem key={item.idMedioPago} value={item.idMedioPago}>
                      {item.descripcion}
                    </MenuItem>
                  ))
                :
                  mediosPago.filter(s => s.habilitado).map((item) => (
                    <MenuItem key={item.idMedioPago} value={item.idMedioPago}>
                      {item.descripcion}
                    </MenuItem>
                  ))
              }
            </SelectValidator>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          style={{ width: "60%", margin: "auto", marginTop: "1.5rem" }}
        >
          <Grid
            item
            xs={12}
            style={{ textAlign: "center", margin: "1rem 0", marginTop: 0 }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={openModalAlertPagoHandler.bind(this, true)}
              disabled={
                montoTotal > 0 &&
                (disabledSaltearPagoButton ||
                  nroLote.length > 0 ||
                  nroCupon.length > 0)
              }
            >
              {montoTotal <= 0 ? "Continuar" : "Saltear Pago"}
            </Button>
          </Grid>
        </Grid>
        {!valorizaciones?.permiteSaltarPago &&
          !valorizaciones?.exento &&
          valorizaciones?.importe > 0 && (
            <Typography
              variant="h6"
              style={{
                color: "#d84848",
                textAlign: "center",
                fontStyle: "italic",
                fontSize: "1.1rem",
              }}
            >
              Solo se permite una vez por grupo familiar.
            </Typography>
          )}
        {valorizaciones?.exento && (
          <Typography
            variant="h6"
            style={{
              color: "#d84848",
              textAlign: "center",
              fontStyle: "italic",
              fontSize: "1.1rem",
            }}
          >
            Afiliado exento de pago.
          </Typography>
        )}
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              margin: "1.5rem 0",
            }}
          >
            <Button
              style={{ margin: "0 2rem" }}
              color="secondary"
              variant="contained"
              onClick={() => {
                props.closeModalCoseguro();
                if(turnoDemanda && openDemandaLaboratorio){
                  dispatch(
                    fetchTurnosTomadosPorFecha(props.fecha.toISOString(), props.idProfesional)
                  );
                  setOpenDemandaLaboratorio(false);
                }
              }}
            >
              Cancelar
            </Button>
            <Button
              color="primary"
              variant="contained"
              disabled={
                montoTotal <= 0 ||
                ((valorizaciones?.exento || valorizaciones?.importe === 0) &&
                  valorizaciones?.deudaAnterior === 0)
              }
              onClick={openModalAlertPagoHandler.bind(this, false)}
            >
              Confirmar Pago
            </Button>
          </Grid>
        </Grid>
      </ValidatorForm>
    </React.Fragment>
  );
};
